import { Component } from '@angular/core';
import { Router } from "@angular/router";
import {
  NbMenuService,
  NbLayoutModule,
  NbCardModule,
  NbButtonModule
} from '@nebular/theme';

@Component({
  selector: 'app-page-not-found',
  imports: [
    NbLayoutModule,
    NbCardModule,
    NbButtonModule
  ],
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent {
  logoUrl: string | undefined;
  
  constructor(
    private menuService: NbMenuService,
    private router: Router) {
  }

  goToHome() {
    this.router.navigate(['']);
    // this.menuService.navigateHome();
    return false
  }
}
